import type { RowSelectionState, Table } from '@tanstack/react-table'
import { createContext, type ReactNode, useContext } from 'react'
import type { UseDataTableOptions } from './types'
import { useDataTable } from './use-data-table'

export interface DataTableContextValue<TData> {
  table: Table<TData>
  rowSelection: RowSelectionState
  setGlobalFilter: (value: string) => void
}

const DataTableContext = createContext<DataTableContextValue<any> | null>(null)

export function useDataTableContext<TData>(): DataTableContextValue<TData> | null {
  return useContext(DataTableContext) as DataTableContextValue<TData> | null
}

interface DataTableRootProps<TData, TValue = unknown> extends UseDataTableOptions<TData, TValue> {
  children: ReactNode
}

export function DataTableRoot<TData, TValue = unknown>({
  children,
  ...hookOptions
}: DataTableRootProps<TData, TValue>) {
  const { table, rowSelection, setGlobalFilter } = useDataTable(hookOptions)

  return (
    <DataTableContext.Provider value={{ table, rowSelection, setGlobalFilter }}>
      {children}
    </DataTableContext.Provider>
  )
}
